import { Group } from '@mantine/core';
import { Text } from '@repo/foundations';
import { IconKey } from '@tabler/icons-react';
import { Handle, Position } from '@xyflow/react';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useLineageFlowContext } from '../../context/LineageFlowProvider/LineageFlowContext';
import { useStyles } from './EntityNodeChild.styles';
import type { EntityNodeChildProps } from './EntityNodeChild.types';

const EntityNodeChild = observer(
	({
		child,
		focused = false,
		highlighted = false,
		order,
	}: EntityNodeChildProps) => {
		const { id, title, metadata } = child;

		const { createAccess, onFetchImpactedChildren } = useLineageFlowContext();

		const { classes, cx, theme } = useStyles({
			highlighted,
			focused,
			order,
			createAccess,
		});

		const handleSelectImpactChild = useCallback(() => {
			onFetchImpactedChildren({
				impactChildID: id,
			});
		}, [id, onFetchImpactedChildren]);

		return (
			<Group className={classes.wrapper} onClick={handleSelectImpactChild}>
				<Handle
					id={`CHILD_TARGET--${id}`}
					className={cx(classes.handle, classes.handleLeft)}
					type="target"
					position={Position.Left}
				/>
				<Handle
					id={`CHILD_SOURCE--${id}`}
					className={cx(classes.handle, classes.handleRight)}
					type="source"
					position={Position.Right}
				/>
				<Text size="sm">{title}</Text>
				<Group spacing="3xs" noWrap>
					{metadata?.is_pk && <IconKey size={theme.other.iconSize.sm} />}
				</Group>
			</Group>
		);
	}
);

export default EntityNodeChild;
